import ContentLoader from 'react-content-loader';

export function SidebarAccountSkeleton(props) {
  return (
    <ContentLoader
      speed={2}
      width={215}
      height={52}
      viewBox="0 0 215 52"
      backgroundColor="#cfe8f7"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="60" y="0" rx="3" ry="3" width="139" height="18" />
      <rect x="60" y="28" rx="3" ry="3" width="87" height="18" />
      <circle cx="30" cy="20" r="20" />
    </ContentLoader>
  );
}
